import { computed, makeAutoObservable } from 'mobx';

import { ConfigTypes } from './types';
import { UniverseType } from 'src_common/common/universe';
import { AmountPrecision } from 'src_common/common/amount/AmountPrecision';
import { getUniverseModule } from 'src/domains/common/universes';
import { Common } from 'src/AppState/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';

export class ConfigState {
    public static get = AutoWeakMap.create((common: Common) => new ConfigState(common));

    private constructor(private readonly common: Common) {
        makeAutoObservable(this);
    }

    @computed public get config(): ConfigTypes {
        return getUniverseModule(this.common).features;
    }

    @computed public get universe(): UniverseType {
        return this.common.appEnvParams.universe_theme;
    }

    public get precision(): AmountPrecision {
        return new AmountPrecision(this.config.decimalLength);
    }
}
